import { schema, types } from 'papr'

export const githubAsSourceSchema = schema(
	{
		user: types.objectId(),
		githubUsername: types.string({ required: true }),
		accessToken: types.string(),
		installationId: types.string(),
		owner: types.string({ required: true }),
		repository: types.string({ required: true }),
		dateAdded: types.date({ required: true }),
		isActive: types.boolean({ required: true }),
		publication: types.objectId(),
		version: types.number(),
	},
	{
		timestamps: true,
		defaults: {
			isActive: true,
			version: 0.1,
		},
	},
)

export type GitHubAsSourceDocument = (typeof githubAsSourceSchema)[0]
export type GitHubAsSourceSchemaOptions = (typeof githubAsSourceSchema)[1]
